store.admin.variants = {};
store.admin.variants.initIndex = function () {
	var $store = $('#store');
	var $buttons = $store.find('.productButtons');
	var $tbody = $store.find('tbody');
	var $checkboxes = $tbody.find('input[type=checkbox]');
	var $sorter = $store.find('tr.sorter');
	var $actionButtons = $buttons.find('li.action');
	$actionButtons.hide();
	var $dialog = $('<div class="" id="savDialog"></div>');

	$actionButtons.find('a[href]').append('<span class="count"/>');
	var $counts = $actionButtons.find('.count');

	var checked = function () {
		var len = $checkboxes.filter(':checked').length;
		if (len > 0) {
			$actionButtons.show();
			$counts.text(" (" + len + ")");
		}
		else {
			$actionButtons.hide();
			$counts.text('');
		}
	};

	var $checkAll = $('<input type="checkbox" class="checkAll" value="1" />');
	$checkAll.change(function () {
		$checkboxes.prop('checked', this.checked);
		checked();
	});
	$sorter.find('th.first').append($checkAll);

	$checkboxes.change(function () {
		checked();
	});

	$actionButtons.find('a').click(function () {
		var $a = $(this);

		var doRun = function () {
			var ids = $checkboxes.filter(':checked').map(function () {
				return this.value;
			}).get();
			var $form = $('<form/>');
			$form.addClass('hide');
			// Must be attached to something
			$(document.body).append($form);
			$form.prop('action', $a.prop('href'));
			$form.prop('method', 'post');
			var $input = $('<input type="hidden" name="ids"/>');
			$input.val(ids.join(','));
			$form.append($input);
			$form.submit();
		};

		var warn = $a.data('warn');
		if (warn) {
			var $p = $('<p/>').text(warn);
			$dialog.append($p);
			$dialog.dialog({
				buttons: {
					"Ok": function () {
						doRun();
						$(this).dialog("close");
					}
				},
				dialogClass: "error",
				height: 180,
				modal: true,
				resizable: false,
				title: $a.text()
			});
		}
		else {
			doRun();
		}

		return false;
	});
};
store.admin.variants.initAttributeValues = function(title){
	var $form = $('#attributeValues');
	$form.find('select.isReq').change(function(){
		var $t = $(this);
		var v = parseInt($t.val());
		if (v > 0) {
			$(this).removeClass('bad');
		}
		else {
			$(this).addClass('bad');
		}
	}).trigger('change');
	$form.find('.firstVariant select').each(function(){
		if (this.disabled) return;
		var $firstSelect = $(this);
		var $p = $firstSelect.parent();
		$('<a class="populateAll" href="#">&nbsp;</a>').attr('title', title)
			.appendTo($p)
			.click(function(e){
				e.preventDefault();
				var mainId = $firstSelect.get(0).id;
				var n = mainId.replace(/.*-/, '');
				var v = $firstSelect.val();
				var reg = new RegExp('-'+n+'$');
				$form.find('select').each(function(){
					if (this.id.match(reg)) {
						if (mainId != this.id) {
							var $t = $(this);
							if ($t.find('option[value='+v+']').length < 1) {
								var label = $firstSelect.find('option[value='+v+']').get(0).text;
								var h = '<option value="'+v+'">'+label+'</option>';
								$(h).appendTo($t);
							}
							$t.val(v);
							$t.trigger('change');
						}
					}
				});
				return false;
			});
	});
};
store.admin.variants.initGeneratorStep2 = function() {
	var $fs = $('fieldset.color');
	$fs.each(function(){
		var $cFs = $(this);
		var $wraps = $cFs.find('.imgWrap');
		$wraps.find('input').change(function(){
			$wraps.removeClass('selected');
			$wraps.find('input:checked').parents('.imgWrap').addClass('selected');
		}).first().trigger('change');
	});
};
store.admin.variants.initPriceGeneratorStep1 = function(errMsg) {
	var $pg = $('.priceGenerator');
	$pg.find('.col .lmnt input').attr('disabled', 'disabled');

	$pg.find('.col label input').change(function(){
		$('.priceGenerator .col .lmnt input').removeAttr('disabled');
		var parentFieldset = $(this).parents('fieldset.col').get(0);
		var myClass = ($(parentFieldset).hasClass('col1')) ? 'col1' : 'col2';
		var otherClass = (myClass == 'col1') ? 'col2' : 'col1';

		$('.priceGenerator fieldset.' + otherClass + ' .lmnt input').attr('disabled', 'disabled');
		$('.priceGenerator fieldset.' + myClass + ' .lmnt input').get(0).focus();
	});
	$pg.find('.col label input').each(function(){
		if ($(this).attr('checked')) {
			$(this).trigger('change');
		}
	});
	$('input[name=priceType]:checked').trigger('change');
	$('form.priceGenerator').submit(function(e){
		var v = $('input[name=priceType]:checked');
		if (v.length < 1) {
			alert(errMsg);
			e.preventDefault();
			return false;
		}
		return true;
	});

};
